import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from '@core/services';

@Injectable()
export class CompanyListAccessInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes('company/list')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse && Array.isArray(event.body)) {
          this.authService.applyCompanyListAccess(event.body);
        }
      })
    );
  }
}
